import apiSlice from "../features/apiSlice";

const uploadVideoApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadVideo: builder.mutation({
      query: (credientials) => {
        return {
          url: `/s3/videoUpload`,
          method: "POST",
          body: credientials
        };
      },
    }),
    downloadVideo: builder.mutation({
      query: (credientials) => {
        return {
          url: `/s3/videoDownload`,
          method: "POST",
          body: credientials
        };
      },
    }),
    uploadPpt: builder.mutation({
      query: (credientials) => {
        return {
          url: `/s3/pptUpload`,
          method: "POST",
          body: credientials
        };
      },
    }),
    uploadPptMock: builder.mutation({
      query: (credientials) => {
        return {
          url: `/s3/pptUpload/mock`,
          method: "POST",
          body: credientials
        };
      },
    }),
    uploadImage: builder.mutation({
      query: (credientials) => {
        return {
          url: `/s3/imageUpload`,
          method: "POST",
          body: credientials
        };
      },
    }),
  }),
});

export const { useUploadVideoMutation, useDownloadVideoMutation, useUploadPptMutation, useUploadImageMutation, useUploadPptMockMutation } = uploadVideoApiSlice;
